<template>
  <v-form ref="form">
    <FormItem name="氏名" required>
      <FlexRow>
        <TextField :value="value.lastName" @input="handleChangeLastName" name="性" :max="50" required />
        <TextField :value="value.firstName" @input="handleChangeFirstName" name="名" :max="50" required />
      </FlexRow>
    </FormItem>
    <FormItem name="役職" required>
      <TextField :value="value.post" @input="handleChangePost" name="役職" :max="50" required />
    </FormItem>
    <FormItem name="アイコン">
      <FlexColumn>
        <UserImage :src="iconUrl" icon />
        <FileSelectField
            v-model="value.icon"
            name="アイコン画像"
            :max-size="10 * 1024 * 1024"
            image
            @input="handleChangeIcon"
            @clearFile="iconData = undefined"
        />
      </FlexColumn>
    </FormItem>
  </v-form>
</template>

<script>
import FormItem from "../molecules/FormItem";
import FlexRow from "../atoms/FlexRow";
import TextField from "../atoms/TextField";
import FlexColumn from "../atoms/FlexColumn";
import UserImage from "../atoms/UserImage";
import FileSelectField from "../atoms/FileSelectField";
export default {
  name: "RequestorForm",
  components: {FileSelectField, UserImage, FlexColumn, TextField, FlexRow, FormItem},
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      iconData: undefined
    }
  },
  computed: {
    iconUrl() {
      if (this.iconData) {
        return this.iconData
      }
      return this.value.imageUrl
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    handleChangeFirstName(value) {
      this.$emit('input', {...this.value, firstName: value})
    },
    handleChangeLastName(value) {
      this.$emit('input', {...this.value, lastName: value})
    },
    handleChangePost(value) {
      this.$emit('input', {...this.value, post: value})
    },
    handleChangeIcon(value) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.iconData = e.target.result;
      };
      reader.readAsDataURL(value);
    },
  }
}
</script>

<style scoped>

</style>